var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWalletTopUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.442,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.641 20.717a.625.625 0 01-.06-.814l.06-.07 5.391-5.391-5.39-5.392a.625.625 0 01-.061-.814l.06-.07a.625.625 0 01.814-.06l.07.06L17.358 14c.222.222.242.569.06.813l-.06.07-5.833 5.834a.625.625 0 01-.884 0z",
    fill: "#424242"
  })));
}

export default SvgWalletTopUp;